// extracted by mini-css-extract-plugin
module.exports = {"container":"Top_container__1xCm2","logo":"Top_logo__2kQGE","sizer":"Top_sizer__3U8lM","userName":"Top_userName__7PIi2","innerContainer":"Top_innerContainer__1v_Cf"};